// extracted by mini-css-extract-plugin
module.exports = {"root":"MoneyCounter_root__eR5fj","amount":"MoneyCounter_amount__bbjy9","noEarnings":"MoneyCounter_noEarnings__L34R7"};